import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useImperativeHandle,
  forwardRef,
} from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { FaRegEdit } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { Text } from "components";
import Breadcrumb from "components/Breadcrumb/Breadcrumb";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const DeliveryChallanItemList = forwardRef((props, ref) => {
  const [deliveryChallanitems, setdeliveryChallans] = useState([]);
  const gridRef = useRef();
  const [download, setDownload] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const { delivery_challan_type_id } = useParams();
  const { customer_id } = useParams();
  console.log(delivery_challan_type_id);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [erplist, setErplist] = useState([]);

  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const showActionColumn = erplist.some(
    (item) => item.erp_module_id === 51 && item.update
  );
  useEffect(() => {
    getAllDeliveryChallanItems();
  }, []);

  const obj = { delivery_challan_id: id };
  const getAllDeliveryChallanItems = () => {
    axios
      .post("/api/purple-fusion/delivarychallanitem/get", obj, headers)
      .then((response) => {
        if (response.data.length < 1) {
          document.getElementById("progress-bar-id").innerHTML =
            "No record found.";
        } else {
          setdeliveryChallans(response.data);
          console.log(response.data);
        }

        localStorage.setItem("data", JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const sorteddeliveryChallanitems = deliveryChallanitems
    .slice()
    .sort((a, b) => b.id - a.id);

  const renderCellValue = (params) => {
    const value = params.value;
    return value === null ? "NA" : value;
  };

  function addPercentageSign(params) {
    return params.value ? `${params.value}%` : 0 + "%";
  }
  // const handelDelete = (id) => {
  //   axios.post('/api/purple-fusion/delivarychallanitem/delete', { id: id }, headers)
  //     .then((response) => {
  //       console.log(response.data);
  //       const message = response.data.message;
  //       if (response.data.status) {
  //         toast.success(message, {
  //           autoClose: 1000,
  //         });
  //         getAllDeliveryChallanItems();
  //       } else {
  //         toast.error(message, {
  //           autoClose: 1000,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  useImperativeHandle(
    ref,
    () => ({
      downloadExcel: () => {
        onBtnExport();
      },
      downloadPdf: () => {
        DownloadPDF();
      },
    }),
    []
  );

  const DownloadPDF = () => {
    const data = JSON.parse(localStorage.getItem("data"));
    const docDefinition = {
      pageOrientation: "landscape",
      header: {
        text: `Delivery Challan Item List`,
        style: "header",
      },
      content: [
        {
          style: "tableExample",
          table: {
            body: [
              [
                [{ text: "SR.NO", style: "tableHeader", bold: true }],
                [{ text: "Item", style: "tableHeader", bold: true }],
                [{ text: "Code", style: "tableHeader", bold: true }],
                [
                  {
                    text: "Item Description",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [{ text: " HSN", style: "tableHeader", bold: true }],
                [{ text: "SAC", style: "tableHeader", bold: true }],
                [{ text: "Quantity ", style: "tableHeader", bold: true }],
                [{ text: "Cost Price ", style: "tableHeader", bold: true }],
                [{ text: "Item Amount ", style: "tableHeader", bold: true }],
                [{ text: "Sgst Amount  ", style: "tableHeader", bold: true }],
                [{ text: "Cgst Amount  ", style: "tableHeader", bold: true }],
                [{ text: "Igst Amount  ", style: "tableHeader", bold: true }],
                [{ text: "Total Tax  ", style: "tableHeader", bold: true }],
                [{ text: "Total Amount  ", style: "tableHeader", bold: true }],
                [{ text: "Created Date", style: "tableHeader", bold: true }],
              ],
              ...data.map((delivarychallanitem, index) => [
                index + 1,
                delivarychallanitem.itemname,
                delivarychallanitem.code_op,
                delivarychallanitem.item_description,
                delivarychallanitem.hsn_code
                  ? delivarychallanitem.hsn_code
                  : "NA",
                delivarychallanitem.sac_code
                  ? delivarychallanitem.sac_code
                  : "NA",
                delivarychallanitem.quantity,
                delivarychallanitem.cost_price,
                delivarychallanitem.item_amount,
                delivarychallanitem.sgst_amount,
                delivarychallanitem.cgst_amount,
                delivarychallanitem.igst_amount,
                delivarychallanitem.total_tax,
                delivarychallanitem.total_amount,
                delivarychallanitem.createdon.substr(0, 10),
              ]),
            ],
            widths: "auto",
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 8, // Set the font size to a smaller value
          color: "#333",
        },
        tableHeader: {
          bold: true,
          fontSize: 10, // You can set a different font size for headers if needed
          color: "#000",
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [10, 10, 10, 20],
          // Add underline
          color: "#333",
        },
      },
    };
    pdfMake.createPdf(docDefinition).download(`Delivery Challan Item List`);
  };

  const onBtnExport = useCallback(() => {
    const options = {
      fileName: `Delivary Challan Item List.csv`, // Specify your desired filename here
    };

    gridRef.current.api.exportDataAsCsv(options);
  }, []);

  const defaultColDefs = [
    { headerName: "Sr.No.", field: "sr", width: 85 },
    { headerName: "ITEM ", field: "itemname", width: 150 },
    { headerName: "CODE ", field: "code_op", width: 150 },
    { headerName: " QUANTITY", field: "quantity", width: 120 },
    {
      headerName: " HSN",
      field: "hsn_code",
      width: 120,
      valueFormatter: renderCellValue,
    },
    {
      headerName: "SAC",
      field: "sac_code",
      width: 120,
      valueFormatter: renderCellValue,
    },
    { headerName: " COST PRICE", field: "cost_price", width: 120 },
    { headerName: " ITEM AMOUNT", field: "item_amount", width: 130 },
    {
      headerName: "SGST",
      field: "sgst_percentage",
      width: 100,
      valueFormatter: addPercentageSign,
    },
    {
      headerName: "CGST",
      field: "cgst_percentage",
      width: 100,
      valueFormatter: addPercentageSign,
    },
    {
      headerName: "IGST",
      field: "igst_percentage",
      width: 100,
      valueFormatter: addPercentageSign,
    },
    { headerName: " SGST AMOUNT", field: "sgst_amount", width: 120 },
    { headerName: " CGST AMOUNT", field: "cgst_amount", width: 120 },
    { headerName: " IGST AMOUNT", field: "igst_amount", width: 120 },
    { headerName: " TOTAL TAX", field: "total_tax", width: 150 },
    { headerName: " TOTAL AMOUNT", field: "total_amount", width: 150 },
    { headerName: " ITEM DESCRIPTION", field: "item_description", width: 150 },
    {
      headerName: "CREATED DATE",
      field: "createdon",
      width: 120,
      valueFormatter: (params) => {
        return params.value.substr(0, 10);
      },
    },
  ];

  const customColDefs = [
    ...defaultColDefs,
    {
      headerName: "",
      field: "id",
      width: 50,
      filter: false,
      pinned: "right",
      cellRenderer: (params) => (
        <div className="flex space-x-4">
          <button
            className="font-small text-blue-600 dark:text-blue-500 mt-2"
            onClick={() => {
              navigate(
                `/delivarychallanitem/edit/${params.value}/${id}/${delivery_challan_type_id}`,
                { state: { customer_id: customer_id } }
              );
            }}
          >
            <FaRegEdit />
          </button>

          {/* <button
            className="font-medium text-blue-500 dark:text-blue-400 mt-2 "
            onClick={() => {
              handelDelete(params.value);
            }}
          >
            Delete
          </button> */}
        </div>
      ),
    },
  ];

  const [colDefs, setColDefs] = useState([]);
  useEffect(() => {
    setColDefs(showActionColumn ? customColDefs : defaultColDefs);
  }, [showActionColumn]);

  // ...

  const ColDefaultVale = { filter: true };

  const gridOptions = {
    overlayNoRowsTemplate: `
        <div id="progress-bar-id" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
        </div>
    `,
  };
  const customStyles = {
    content: {
      width: "20%",
      height: "20%",
      margin: "auto",
      border: "1px solid #ccc",
      borderRadius: "8px",
    },
  };
  return (
    <>
      {erplist.some((item) => item.erp_module_id === 51 && item.view) ? (
        <div className="overflow-hidden">
          <div className="flex  flex-row w-full items-center my-3">
            {/* <Text
            className="md:text-[22px] whitespace-nowrap text-gray-800 sm:text-xl tracking-[0.20px] w-[85px] text-base"
            size="txtInterSemiBold24"
          >
           <div className="flex flex-row gap-1">
                  <div
                    className="hover:cursor-pointer whitespace-nowrap underline "
                    onClick={() => navigate("/delivarychallan/list")}
                  >
                    <Text className="text-base whitespace-nowrap">
                    Delivery Challan
                    </Text>
                  </div>
                  <Text className="text-base whitespace-nowrap">
                    /
                    </Text>
                    <Text className="text-base whitespace-nowrap">
                      Items
                    </Text>
                </div>  
          </Text> */}
            <Breadcrumb
              items={[
                {
                  label: "Delivery Challan",
                  path: "/delivarychallan/list",
                },
                {
                  label: "Items",
                },
              ]}
            />

            <div className="flex text-3xl ml-12 relative flex-row justify-end items-center font-inter gap-2 px-[10px] w-full leading-none tracking-tight text-gray-900 md:text-4xl lg:text-5xl dark:text-white ">
              <div
                className="flex flex-col relative z-20"
                onMouseEnter={() => setDownload(!download)}
                onMouseLeave={() => setDownload(!download)}
              >
                <button
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  type="button"
                >
                  {"Download"} &nbsp;{" "}
                  <svg
                    className="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
                <div
                  className={`${
                    download ? "absolute top-[32px]" : "hidden"
                  } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[125px] bg-white-A700  dark:bg-gray-700`}
                >
                  <ul
                    className="py-0 text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    <li>
                      <a
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={DownloadPDF}
                      >
                        PDF
                      </a>
                    </li>
                    <li>
                      <a
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={onBtnExport}
                      >
                        Excel
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {erplist.some(
                (item) => item.erp_module_id === 51 && item.add
              ) && (
                <Link
                  // to={`/delivarychallanitem/add/${id}/${delivery_challan_type_id}/${customer_id}`}
                  to={
                    Number(delivery_challan_type_id) == 5
                      ? `/delivarychallanitem/jobwork/add/${id}/${delivery_challan_type_id}/${customer_id}`
                      : `/delivarychallanitem/add/${id}/${delivery_challan_type_id}/${customer_id}`
                  }
                >
                  <div className="flex flex-col items-center justify-center">
                    <button
                      type="button"
                      id="dropdownDefaultButton"
                      className="text-white-A700 bg-blue-700  hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 "
                    >
                      + Add
                    </button>
                  </div>
                </Link>
              )}
            </div>
          </div>

          <ToastContainer />
          <div
            className="ag-theme-quartz"
            // style={{ height: 500, width: "100%", fontSize: "12px" }}
            id="my-table1"
          >
            <AgGridReact
              ref={gridRef}
              rowData={sorteddeliveryChallanitems.map(
                (delivarychallanitem, index) => ({
                  ...delivarychallanitem,
                  sr: index + 1,
                })
              )}
              columnDefs={colDefs}
              pagination={true}
              defaultColDef={ColDefaultVale}
              suppressMenuHide={true}
              suppressExcelExport={true}
              gridOptions={gridOptions}
            />
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
});

export default DeliveryChallanItemList;
